import { Link } from 'react-router';
import type { TileSize } from '../../../tiles/registry';
import { cn } from '../../../ui/cn';
import { spokenPeso } from '../../../ui/spokenPeso';
import { BigAmount, signedPeso } from '../components/MoneyCards';
import { copy } from '../copy';
import { accountStatusesOf, moneyOnHandOf, spendingStatusesOf } from '../derive';
import { useBudgetToday } from '../hooks';
import { FOCUS } from '../styles';

/** v0.5 Today tile "Your money": the total, and (wide) each account with its balance. */
export function YourMoneyTile({ size }: { size: TileSize }) {
  const s = useBudgetToday();
  if (!s) return <p className="text-sm text-muted">{copy.loading}</p>;
  const statuses = spendingStatusesOf(s);
  if (accountStatusesOf(s).length === 0) {
    return (
      <p className="text-sm text-muted">
        {copy.addYourAccounts}{' '}
        <Link to="/m/budget/accounts/new" className={`text-primary ${FOCUS}`}>
          {copy.addAccount}
        </Link>
      </p>
    );
  }
  const total = moneyOnHandOf(s);
  return (
    <Link
      to="/m/budget/accounts"
      aria-label={`${copy.yourMoney}, ${total < 0 ? 'minus ' : ''}${spokenPeso(Math.abs(total))}`}
      className={`flex flex-col gap-1 [container-type:inline-size] ${FOCUS}`}
    >
      <BigAmount minor={total} maxPx={size === 'small' ? 30 : 36} testId="your-money-total" />
      {size !== 'small' ? (
        <ul className="mt-1 flex flex-col text-sm">
          {statuses.slice(0, 5).map((a) => (
            <li key={a.account.id} className="flex items-center justify-between gap-3">
              <span className="min-w-0 truncate text-muted">{a.account.name}</span>
              <span
                className={cn(
                  'shrink-0 font-mono tabular-nums',
                  a.balanceMinor < 0 ? 'text-destructive' : 'text-fg',
                )}
              >
                {signedPeso(a.balanceMinor)}
              </span>
            </li>
          ))}
        </ul>
      ) : null}
    </Link>
  );
}
